module.exports = __webpack_public_path__ + "img/crown2.2807a374.png";